import React, { Component } from 'react'
import { withRouter } from "react-router"
import logo from '../images/logo.png'

export class Header extends Component {

  styles = {

    header: {
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'nowrap',
      justifyContent: 'space-between',
      marginBottom: '0.1in'
    },

    section: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between'
    },

    center: {
      margin: '38px 0 20px 0'
    },
    genie: {
      display: 'flex',
      flexDirection: 'row'
    },

    bar: {
      width: '100%',
      height: '0.05in',
      marginTop: '0.05in',
    },

    blueBar: {
      backgroundColor: '#006595',
    },

    greenBar: {
      backgroundColor: '#7B7139',
    },

    logo: {
      width: '2in',
      height: '1in',
      marginTop: '16px',
    },

    url: {
      color: '#006595'
    },

    patientId: {
      fontSize: 'x-large',
      marginBottom: '10px'
    },


    italic: {
      fontStyle: 'italic'
    },

    bold: {
      fontWeight: 'bold'
    },
  }


  render() {

    const { url, phone, email, reportDate, patientId, CLIADirector, CLIALicense, orderDate, drawDate, assayDate } = this.props.header

    return (
      <div className="no-break-print" style={ this.styles.header }>
        <div style={ this.styles.section }>
          <img style={ this.styles.logo }
               src={ logo }
               alt='img' />
          <div style={this.styles.center}>
            <div style={ this.styles.url }>{ url }</div>
            <div>Phone: { phone }</div>
            <div>Email: { email }</div>
          </div>

          <div>
            <div style={ this.styles.patientId }>Patient ID: { patientId }</div>
            <div>CLIA Director: { CLIADirector }</div>
            <div>CLIA License: { CLIALicense }</div>
            <div>Draw Date: { drawDate }</div>
            <div>Report Date: { new Date().toLocaleDateString() }</div>
          </div>
        </div>

        <div style={ this.styles.section }>

          <div style={ this.styles.genie }>
            <div style={ { ...this.styles.bold, ...this.styles.larger, ...this.styles.italic } }>GENIE REPORT
              -&nbsp;</div>
            <div style={ { ...this.styles.larger, ...this.styles.italic } }>Gene Expression:Inflammation Explained</div>
          </div>

        </div>

        <div style={ { ...this.styles.blueBar, ...this.styles.bar } } />
        <div style={ { ...this.styles.greenBar, ...this.styles.bar } } />


      </div>
    )
  }
}

export default withRouter(Header)